import { Component, OnInit, TemplateRef, ViewChild, HostListener  } from '@angular/core';
import { ActivatedRoute, NavigationExtras} from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import * as XLSX from 'xlsx';

import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { ChecklistFacade } from '../../../common/facade/ChecklistFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { StoreScheduleFacade } from '../../../common/facade/StoreScheduleFacade';
import { ConfigurationFacade } from '../../../common/facade/ConfigurationFacade';
import { ApplicationFacade } from '../../../common/facade/ApplicationFacade';
import { CampaignCalendarFacade } from '../../../common/facade/CampaignCalendarFacade';

import { StoreChecklistParams } from '../../../common/model/StoreChecklistParams';
import { ChecklistDto } from '../../../common/model/dto/ChecklistDto';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { CatalogDetInfo } from '../../../common/model/dictionary/CatalogDetInfo';
import { OrganizationFacade } from '../../../common/facade/OrganizationFacade';
import { Organization } from '../../../common/model/Organization';
import { CatalogDet } from '../../../common/model/CatalogDet';
import { Checklist } from '../../../common/model/Checklist';

// for excel import
type AOA = any[][];

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.css']
})
export class ChecklistComponent implements OnInit {

  placeHolder = 'Ingrese nombre de campaña';
  keyword = 'name';

  // Properties and Attributes *******************************
  isSpanish = true;
  _organizationId = '';
  organizationUnSelected = '-1';
  titleActivityScheduler = res.ActivityScheduler;
  lblInvoice = res.Reference;
  lblSave = res.Save;
  lblMandatoryInformation = res.MandatoryInformation;
  titleGeneralData = res.GeneralData;
  lblChecklistFunctionality = res.ChecklistFunctionality;
  lblSelectAnOption = res.SelectAnOption;
  lblAssignedStores = res.AssignedStores;
  lblStores = res.Stores;
  lblTitle = res.Title;
  lblEnterTitle = res.EnterTitle;
  lblStatus = res.StatusTask;
  lblCampaign = res.Campaign;
  lblAddCampaign = res.AddCampaign;
  lblEditCampaign = res.EditCampaign;
  titleNotice = res.Notice;
  lblRequiresNotice = res.RequiresNotice;
  lblNoticeDate = res.NoticeDate;
  lblNoticeAttachedDocument = res.NoticeAttachedDocument;
  lblSelectAFile = res.SelectAFile;
  lblChoose = res.Choose;
  lblRequiresReadingNotice = res.RequiresReadingNotice;
  titleActivityScheduling = res.ActivityScheduling;
  lblPeriodicity = res.Periodicity;
  lblRepeat = res.Repeat;
  lblMonday = res.Monday;
  lblMondayAbbr = 'JK';
  lblTuesday = res.Tuesday;
  lblTuesdayAbbr = res.TuesdayAbbr;
  lblWednesday = res.Wednesday;
  lblWednesdayAbbr = res.WednesdayAbbr;
  lblThursday = res.Thursday;
  lblThursdayAbbr = res.ThursdayAbbr;
  lblFriday = res.Friday;
  lblFridayAbbr = res.FridayAbbr;
  lblSaturday = res.Saturday;
  lblSaturdayAbbr = res.SaturdayAbbr;
  lblSunday = res.Sunday;
  lblSundayAbbr = res.SundayAbbr;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  titleValidityOfTheChecklist = res.ValidityOfTheChecklist;
  titleRestrictChecklistHours = res.RestrictChecklistHours;
  lblRequiresMaxExecutionTime = res.RequiresMaxExecutionTime;
  lblMaximumTimeRequired = res.MaximumTimeRequired;
  lblLayoutDownload = res.LayoutDownload;
  lblDownload = res.Download;
  lblUploadInstructionsFile = res.UploadInstructionsFile;
  lblLevelOne = res.LevelOne;
  lblInstruction = res.Instruction;
  lblDetail = res.Detail;
  lblMaximumImages = res.MaximumImages;
  lblMinimumImages = res.MinimumImages;
  lblComments = res.Comments;
  lblAnswers = res.Answers;
  lblCaptureMayus = res.CaptureMayus;
  lblSelectStores = res.SelectStores;
  lblFilters = res.Filters;
  lblStoreType = res.StoreType;
  lblBrand = res.Brand;
  lblOpeningHours = res.OpeningHours;
  lblClosingHours = res.ClosingHours;
  lblAllMayusA = res.AllMayusA;
  lblAllMayusO = res.AllMayusO;
  lblSearch = res.Search;
  lblName = res.Name;
  lblCheckUnchekAll = res.CheckUnchekAll;
  lblAccept = res.Accept;
  lblDeadline = res.Deadline;
  lblAnswer = res.Answer;
  lblScore = res.Score;
  lblMessage = res.Message;
  lblCancel = res.Cancel;
  lblOrganization = res.Organization;
  lblYes = res.Yes;
  lblNot = res.Not;
  lblNotAssigned = res.NoOrganizationAssigned;

  fileNameUpload = '';

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };
  @ViewChild('tableStore') tableStore: DatatableComponent;
  @ViewChild('tableAnswer') tableAnswer: DatatableComponent;

  Checklist: ChecklistDto = new ChecklistDto();
  configurationNotificationFile: any;
  maxSizeNotificationFile = 0; // size in Byte
  currentDate = new Date();
  isNewChecklist = false;

  lsTaskType: any[] = [];
  lsProgramation: any[] = [];
  lsStatus: any[] = [];
  lsNotificationDay: any[] = [];
  lsStoreType: any[] = [];
  lsCampaign: any[] = [];
  lsCampaignCalendar: any[] = [];
  lsMark: any[] = [];
  lsOpeningTime: any[] = [];
  lsClosingTime: any[] = [];
  rows: any[] = [];
  rowsModal: any[] = [];
  lsStores: any[] = [];

  lsInstruction: any[] = [];
  rowsAnswer: any = [];
  layout_table: any = [];

  // Query params
  _action: number;
  _taskId: number;
  _checklistId: number;
  _checklistStatus: number;

  // actions
  add = 1;
  see = 2;
  edit = 3;

  // HTML elements
  readonly = false;
  stopEditing = false;

  cmb_functionality = -1;
  cmb_campaign = -1;
  btnEditCampaign = false;
  btnAddCampaign = false;
  txt_title = '';
  cmb_organization = '';
  campaign: string;
  txt_campaign = '';
  cmb_status = 18; // VIGENTE

  cmb_notification: any = -1;
  cmb_notification_date = -1;
  dateFileToUpload: File = null;
  fileToUpload: any = null;
  txta_notification = '';
  check_readNotif = false;

  cmb_periodicity = -1;
  check_day1 = false;
  check_day2 = false;
  check_day3 = false;
  check_day4 = false;
  check_day5 = false;
  check_day6 = false;
  check_day7 = false;
  txt_start_date = new Date();
  txt_end_date = new Date();
  txt_min_date = new Date();

  cmb_type_modal = -1;
  cmb_mark_modal = -1;
  cmb_openShedule_modal = '00:00:00';
  cmb_closeSchedule_modal = '00:00:00';

  txt_campaignAdd = '';
  txt_start_date_campaign = new Date();
  txt_end_date_campaign = new Date();
  txt_organizationId_campaignAdd: '';

  cmb_campaignEdit = -1;
  txt_start_date_campaignEdit = new Date();
  txt_end_date_campaignEdit = new Date();
  txt_organizationId_campaignEdit: '';

  check_isMaximumTimeRequired = false;
  maximumTimeRequired = {hour: 0, minute: 0, second: 0};
  meridian = true;


  // import excel
  excelData: AOA = [ [], [] ];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName = 'SheetJS.xlsx';

  // loader
  loading = false;
  messageLoader = '';

  isCollapsed = false;
  iconCollapse = 'icon-arrow-up';

  isCollapsedNotification = false;
  iconCollapseNotification = 'icon-arrow-up';

  isCollapsedProgramation = false;
  iconCollapseProgramation = 'icon-arrow-up';

  isCollapsedRestrict = false;
  iconCollapseRestrict = 'icon-arrow-up';

  isCollapsedLayout = false;
  iconCollapseLayout = 'icon-arrow-up';

  // Controls
  signing1: String = '';
  disabledSigning1: Boolean = false;

  signing2: String = '';
  disabledSigning2: Boolean = false;

  // modal
  modalStore: BsModalRef;
  modalAnswers: BsModalRef;
  modalSave: BsModalRef;
  modalAddCampaign: BsModalRef;
  modalEditCampaign: BsModalRef;
  config = {
    ignoreBackdropClick: true // si es false se cierra el modal dar clic fuera de el
  };
  check_selectAll = false;
  _filteredData = [];

  // alert
  generalAlerts: any[] = [];
  alertsFileExcel: any[] = [];
  alertsFilePdf: any[] = [];
  alertsAddCampaign: any[] = [];
  alertsEditCampaign: any[] = [];

  readOnlyEndDate = false;
  private _periodicityWeekenly = 152;
  private _periodiciteOneTime = 151;
  cmb_organization_campaignEdit = -1;
  cmb_organization_campaignAdd = '-1';
  language = 0;
  public tenantId = 0;
  public _availableOrganizations: Organization[] = [];
  public organizationList: Organization[] = [];
  
  public disableButtonStores = true;
  public disableSelectorOrg = false;
  public isSmallScreen: boolean = false;
  public extras: NavigationExtras;
  public path: string = 'admin'

  constructor(
    private modalService: BsModalService,
    private _facadeCatDet: CatalogDetFacade,
    private _facadeChecklist: ChecklistFacade,
    private _facadeStore: StoreFacade,
    private _facadeStoreSchedule: StoreScheduleFacade,
    private _facadeConfiguration: ConfigurationFacade,
    private _facadeApplication: ApplicationFacade,
    private _facadeCampaignCalendar: CampaignCalendarFacade,
    private _route: ActivatedRoute,
    public strings: Strings
  ) {
      this.txt_start_date = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate());
      this.txt_start_date.setDate(this.txt_start_date.getDate() + 1);

      this.txt_end_date = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate());
      this.txt_end_date.setDate(this.txt_end_date.getDate() + 1);

      this.txt_min_date = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate());
   }
  
   @HostListener('window:resize', ['$event'])
   onResize(event: any): void {
     this.verifyScreenSize();
   }

   private verifyScreenSize(): void {
    this.isSmallScreen = window.innerWidth <= 600; // Puedes ajustar este valor según tus necesidades
  }


  ngOnInit() {
    this.verifyScreenSize();
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.language = 0;
    if (!this.isSpanish) {
        this.language = 1;
    }
    this.tenantId = this.strings.getTenant();
    this._availableOrganizations = this.strings.getAvailableOrganizations();
    this.organizationList = this._availableOrganizations.filter(Orga => Orga.tenantId == this.tenantId);
    this.cmb_organization = this.organizationUnSelected;

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    // get route params
    this._route.queryParams.subscribe(params => {
      this._action = Number(params['action']);
      this._taskId = Number(params['taskId']);
      this._checklistId = Number(params['checklistId']);
      this._checklistStatus = params['status'];
    });

    this.extras = {
      queryParams: {
          'status': this._checklistStatus
      }
    }

    this.disableButtonStores = this._action === this.see;

    this._facadeApplication.GetCurrentDate().subscribe(result => {
        this.currentDate = result.substring(0, 10);
      }, error => {
        this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
        return;
      });

    // get max size for notification file
    this._facadeConfiguration.GetConfiguration(4).subscribe(result => {
        if (result.completed) {
          this.configurationNotificationFile = result.data;
          this.maxSizeNotificationFile = this.configurationNotificationFile.value;
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    // get TaskType
    this._facadeCatDet.Get(3, this.language).subscribe(result => {
        if (result.completed) {
          result.data.forEach(element => {
            const splits = element.auxiliary.split('|', element.auxiliary.length);
            if (splits[0] == '1') {
              this.lsTaskType.push(element);
            }
          });
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    // get Programation
    this._facadeCatDet.Get(4, this.language).subscribe(result => {
        if (result.completed) {
            this.lsProgramation = result.data;
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    // get Status
    this._facadeCatDet.Get(18, this.language).subscribe(result => {
        if (result.completed) {
            this.lsStatus = result.data;
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    // get notification day
    this._facadeCatDet.Get(19, this.language).subscribe(result => {
        if (result.completed) {
            this.lsNotificationDay = result.data;
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    this.getStoreTypes();
    this.getTradeMarks();
    
    // get campaigns
    this._facadeCatDet.Get(42, this.language).subscribe(result => {
        if (result.completed) {
            this.lsCampaign = result.data;
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    // get campaignsCalendar
    this._facadeCampaignCalendar.Get(102).subscribe(result => {
        if (result.completed) {
            this.lsCampaignCalendar = result.data;
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    // get OpeningTime
    this._facadeStoreSchedule.GetSchedule(1).subscribe(result => {
        if (result.completed) {
            this.lsOpeningTime = result.data;
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    // get ClosingTime
    this._facadeStoreSchedule.GetSchedule(2).subscribe(result => {
        if (result.completed) {
            this.lsClosingTime = result.data;
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });

    // get ChecklistData
    this._facadeChecklist.GetChecklistData(this._taskId, this._checklistId).subscribe(result => {
        if (result.completed) {
            this.Checklist = result.data;
            this.cmb_organization = this.Checklist.checklist.organizationId; 
            // llenar formulario en caso de que la acción sea "ver checklist" o "editar checklist"
            if (this._action == this.see || this._action == this.edit) {
              if (this._action == this.see) {
                this.readonly = true;
                this.disableSelectorOrg = true;
              }
              this.getStoreTypes()
              this.fillForm();
            }
        }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });
  }

  getStoreTypes() {
    // get store type
    this.loading = true;
    this._facadeCatDet.Get(16, this.language, this.cmb_organization).subscribe(result => {
      if (result.completed) {
          this.lsStoreType = result.data;
      }
      this.loading = false;
  }, error => {
    this.loading = false;
    this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
    return;
  });
  }
  
  getTradeMarks() {
    this.loading = true;
    this._facadeCatDet.Get(15, this.language, this.cmb_organization).subscribe(result => {
      if (result.completed) {
          this.lsMark = result.data;
      }
      this.loading = false;
    }, error => {
    this.loading = false;
    this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
    return;
    });
  }

  fillForm() {
    this.loading = true;
    if (this._action == this.edit) {
      if (this.Checklist.taskSchedule.startDate <= this.currentDate) {
        this.readonly = true;
      }

      if (this.Checklist.taskSchedule.endDate >= this.currentDate) {
          this.stopEditing = true;
      }

      if (this.Checklist.taskSchedule.catDetTaskSchedTypeId == this._periodiciteOneTime) {
          this.readOnlyEndDate = true;
      }
    }

    if (this._action != this.add) {
      if (this.Checklist.task.campaignCalendarId > 0) {
        if (this.Checklist.task.catDetTaskTypeId == 102) {
          this.loadCampaigns(this.Checklist.task.campaignCalendarId);
        } else {
          this.cmb_campaign = this.Checklist.task.campaignCalendarId;
        }
      }

      if (this.Checklist.task.sendNotification) {
        if (this.Checklist.notificationDocument != null) {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertUploadedFile) + ' "' + this.Checklist.notificationDocument.blobName + '"<strong>', 'info', 'pdf');
        } else {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertNoUploadedFileFound) + '<strong>', 'danger', 'pdf');
        }
      }
    }

    this.cmb_functionality = this.Checklist.task.catDetTaskTypeId;
    this.txt_title = this.Checklist.task.title;

    this.cmb_status = this.Checklist.task.catDetTaskStatusId;

    if (this.Checklist.task.sendNotification) {
      this.cmb_notification = 1;
    } else {
      this.cmb_notification = 0;
    }

    this.cmb_notification_date = this.Checklist.task.catDetNotificationDateId;
    this.txta_notification = this.Checklist.task.notificationMessage;
    this.check_readNotif = this.Checklist.task.lockedBeforeReadNotif;

    this.cmb_periodicity = this.Checklist.taskSchedule.catDetTaskSchedTypeId;

    this.Checklist.taskSchedule.detail.forEach(element => {

        switch (element.numberDay) {
          case 1: {
            if (element.active) {
              this.check_day1 = true;
            }
            break;
          }
          case 2: {
            if (element.active) {
              this.check_day2 = true;
            }
              break;
          }
          case 3: {
            if (element.active) {
              this.check_day3 = true;
            }
            break;
          }
          case 4: {
            if (element.active) {
              this.check_day4 = true;
            }
            break;
          }
          case 5: {
            if (element.active) {
              this.check_day5 = true;
            }
            break;
          }
          case 6: {
            if (element.active) {
              this.check_day6 = true;
            }
            break;
          }
          case 7: {
            if (element.active) {
              this.check_day7 = true;
            }
            break;
          }
        }
    });

    // 116 -> Checklist Inventarios
    if (this.cmb_functionality == 116) {
      this.txt_start_date = this.Checklist.taskSchedule.startDate;
      this.txt_end_date = this.Checklist.task.maximumDateRequired;
    } else {
      this.txt_start_date = this.Checklist.taskSchedule.startDate;
      this.txt_end_date = this.Checklist.taskSchedule.endDate;
    }

    if (this.Checklist.task.maximumTimeRequired != null) {
      const split = this.Checklist.task.maximumTimeRequired.split(':');
      this.maximumTimeRequired.hour = parseInt(split[0], 10);
      this.maximumTimeRequired.minute = parseInt(split[1], 10);
      this.maximumTimeRequired.second = parseInt(split[2], 10);
    }
    this.check_isMaximumTimeRequired = this.Checklist.task.isMaximumTimeRequired;
    this.lsInstruction = this.Checklist.checklist.instructions;

    this.loading = false;
  }

  // habilitar o deshabilitar campos de firmas
  enableSigning(signing: number) {
    if (signing == 1) {
      this.disabledSigning1 = !this.disabledSigning1;
      this.signing1 = '';
    } else {
      this.disabledSigning2 = !this.disabledSigning2;
      this.signing2 = '';
    }
  }

  onChangeOrganization() {
    if(this.cmb_organization != this.organizationUnSelected) {
      this.disableButtonStores = false
    }
    else {
      this.disableButtonStores = true
    }

    this.rowsModal.forEach( (item, index) => {
      if (item.organizationId != this.cmb_organization){
        item.selected = false
      }
    });

    this.getStoreTypes();
    this.getTradeMarks();
    let lsAuxStores = []
    this.lsStores.forEach( (item, index) => {
      
      if (this.cmb_organization == item.organizationId){
        lsAuxStores.push(item)
      }
    });
    this.lsStores = lsAuxStores
    this.saveStores(false)

    if(this.cmb_functionality == 102) {
      this.getCampaignByFunctionality();
    }
  }

  /* #region Cards */
  collapsed(event: any): void {
  }

  expanded(event: any): void {
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  collapsedNotification(event: any): void {
  }

  expandedNotification(event: any): void {
  }

  toggleCollapseNotification(): void {
    this.isCollapsedNotification = !this.isCollapsedNotification;
    this.iconCollapseNotification = this.isCollapsedNotification ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  collapsedProgramation(event: any): void {
  }

  expandedProgramation(event: any): void {
  }

  toggleCollapseProgramation(): void {
    this.isCollapsedProgramation = !this.isCollapsedProgramation;
    this.iconCollapseProgramation = this.isCollapsedProgramation ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  collapsedRestrict(event: any): void {
  }

  expandedRestrict(event: any): void {
  }

  toggleCollapseRestrict(): void {
    this.isCollapsedRestrict = !this.isCollapsedRestrict;
    this.iconCollapseRestrict = this.isCollapsedRestrict ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  collapsedLayout(event: any): void {
  }

  expandedLayout(event: any): void {
  }

  toggleCollapseLayout(): void {
    this.isCollapsedLayout = !this.isCollapsedLayout;
    this.iconCollapseLayout = this.isCollapsedLayout ? 'icon-arrow-down' : 'icon-arrow-up';
  }
  /* #endregion */

  startToggleMeridian() {
    this.meridian = !this.meridian;
  }

  getRowHeight(row) {
    return row.height;
  }

  // Abrir modal de tiendas seleccionadas
  openModal(template: TemplateRef<any>) {
    this.check_selectAll = false;
    this.cmb_type_modal = -1;
    this.cmb_mark_modal = -1;
    this.cmb_openShedule_modal = '00:00:00';
    this.cmb_closeSchedule_modal = '00:00:00';

    this.getStoreChecklist();

    this.modalStore = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' }, this.config)
    );
    }

  // Abrir modal para agregar una campaña
  openModalAddCampaign(template: TemplateRef<any>) {
    this.txt_campaign = null;
    this.txt_campaignAdd = '';
    this.txt_start_date_campaign = null;
    this.txt_end_date_campaign = null;

    this.modalAddCampaign = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg modal-success' }, this.config)
    );
  }

  // Abrir modal para editar una campaña
  openModalEditCampaign(template: TemplateRef<any>) {
    this.cmb_campaignEdit = -1;
    this.cmb_organization_campaignEdit = -1;
    this.txt_start_date_campaignEdit = null;
    this.txt_end_date_campaignEdit = null;
    this.cmb_organization_campaignEdit = -1;

    this.modalEditCampaign = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg modal-primary' }, this.config)
    );
  }

  // realizar filtro en la tabla de tiendas seleccionadas cuándo se teclea en la caja de texto
  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the amount of columns in the table
    const colsAmt = 7;

    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rowsModal = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 1; i < keys.length; i++) {

            if (item[keys[i]] != null &&
                (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });

    this.tableStore.offset = 0;
  }

  checkAll() {
    this.check_selectAll = !this.check_selectAll;
    this.lsStores = [];
    if (this.check_selectAll) {
      this.rowsModal.forEach(element => {
        this.lsStores.push(element);
        element.selected = true;
      });
    } else {
      this.rowsModal.forEach(element => {
        element.selected = false;
      });
    }
  }

  // Abrir modal de respuestas para la instrucción seleccionada
  openModalAnswers(template: TemplateRef<any>, objAnswers: any) {
    this.rowsAnswer = objAnswers.answers;

    this.modalAnswers = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' }, this.config)
    );
  }

  // Abrir modal despues de dar click en "Guardar"
  openModalSave(template: TemplateRef<any>) {
    this.modalSave = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-sm' }, this.config)
    );
  }

  // Obtener el listado de tiendas activas por los filtros seleccionados
  getStoreChecklist() {
    this.loading = true;

    const store: StoreChecklistParams = new StoreChecklistParams();
    store.CatDetStoreTypeId = this.cmb_type_modal;
    store.CatDetTradeMarkId = this.cmb_mark_modal;
    store.OpeningTime = this.cmb_openShedule_modal;
    store.ClosingTime = this.cmb_closeSchedule_modal;
    store.OrganizationId = this.cmb_organization;
    store.CatDetCountryId =
      CatalogDetInfo.USACatalogs.includes(this.cmb_functionality.toString())
       ? CatalogDetInfo.catDetCountryUSAId
       : CatalogDetInfo.catDetCountryMXId;

    this._facadeStore.GetStoreChecklist(store).subscribe(result => {
        if (result.completed) {
            this.lsStores = [];
            let lsStoresModalAux = [];

            result.data.forEach(element => {
              if(this.cmb_organization == element.organizationId) {
                lsStoresModalAux.push(element)
              }
            });

            this.rowsModal = lsStoresModalAux;
            this._filteredData = lsStoresModalAux;

            // only check the selected store
            if (this.Checklist.stores != null) {
              this.lsStores = (JSON.parse(JSON.stringify(this.Checklist.stores)));
              this.Checklist.stores.forEach(stores => {
                this.rowsModal.forEach(store => {
                  if (stores.storeId == store.storeId) {
                    store.selected = true;
                  }
                });
              });
            }
        }
        this.loading = false;
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
      return;
    });
  }

  // Método que se ejecuta al cambiar la selección de "Requiere aviso", inicializa los componentes
  onChangeNotificationRequired() {
    if (this._action == this.edit) {
      if (!this.Checklist.task.sendNotification) {
        if (this.cmb_notification == 1) {
          this.Checklist.newNotificationDoc = true;
        } else {
          this.Checklist.newNotificationDoc = false;
        }
      }
    }
    this.cmb_notification_date = -1;
    this.txta_notification = '';
    this.check_readNotif = false;
    this.dateFileToUpload = null;
    this.alertsFilePdf = [];
  }

  onChangeCampaign(value) {
    const campaign =  this.lsCampaignCalendar.find( x => x.campaignCalendarId == Number(value));
    this._organizationId = campaign.organizationId;
    this.getStoreChecklist();
    //this.getTradeMarks(campaign.organizationId);
  }

  onChangeFuncionality() {
    this.check_isMaximumTimeRequired = false;
    this.cmb_organization = this.organizationUnSelected;
    this.onChangeOrganization();

    if (this._action == 1) {
      this.cmb_campaign = -1;
      // 102 -> Cambio de Nivel
      if (this.cmb_functionality == 102) {
        this.getCampaignByFunctionality();
      }
    }
  }

  onChangePeriodicity() {
      if (this.cmb_periodicity == this._periodiciteOneTime) {
          this.readOnlyEndDate = true;
          this.txt_end_date = this.txt_start_date;
      } else {
          this.readOnlyEndDate = false;
      }
  }

  onChangeStartDate(value) {
    if (this.readOnlyEndDate) {
        this.txt_end_date = value;
    }
    this.txt_start_date = value;
  }

  onChangeStartDateAddCampaign(value) {
    this.txt_start_date_campaign = value;
  }

  onChangeEndDateAddCampaign(value) {
    this.txt_end_date_campaign = value;
  }

  // Método que se ejecuta al cambiar la selección de "Requiere aviso", inicializa los componentes
  onChangeSelectedStore(value) {
    this.rowsModal.forEach(function (val) {
      if (val.storeId == value.storeId) {
        val.selected = !val.selected;
      }
    });

    const store = this.lsStores.find( x => x.storeId == value.storeId);
    if (store != null) {
      this.lsStores.forEach( (item, index) => {
        if (item.storeId === store.storeId) {
          this.lsStores.splice(index, 1);
        }
      });
    } else {
      this.lsStores.push(value);
    }
  }

  // Método que se ejecuta al cambiar la selección de "Requiere aviso", inicializa los componentes
  onChangeEditCampaign() {
    if (this.cmb_campaignEdit > 0) {
      const campaignAux = this.lsCampaignCalendar.find( x => x.campaignCalendarId == Number(this.cmb_campaignEdit));
      this.txt_start_date_campaignEdit = campaignAux.startDate;
      this.txt_end_date_campaignEdit = campaignAux.endDate;
      this.cmb_organization_campaignEdit = campaignAux.organizationId;
    } else {
      this.txt_start_date_campaignEdit = null;
      this.txt_end_date_campaignEdit = null;
    }
  }

  getCampaignByFunctionality() {
    this.loading = true;
    this._facadeCampaignCalendar.GetByTaskOrganization(Number(this.cmb_functionality), this.cmb_organization).subscribe(result => {
      if (result.completed) {
          
          this.lsCampaignCalendar = result.data;
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'addCampaign');
      return;
    });
  }

  // Método para guardar las tiendas seleccionadas para la que aplicará el checklist
  saveStores(closeModal = true) {
    const stores: any[] = [];

    this.lsStores.forEach(element => {
      const store = {
        active: true,
        catDetTaskTypeId: 0,
        storeId: element.storeId,
        storeName: element.storeName,
        taskId: this._taskId,
        storesId: 0,
        organizationId: element.organizationId
      };
      stores.push(store);
    });
    this.Checklist.stores = stores;
    if (closeModal) {
      this.modalStore.hide();
    }
  }

  // Método que se ejecuta al seleccionar un archivo para aviso
  uploadNotificationFile(event) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertSelectOnlyOneFile), 'danger', 'pdf');
      return;
    }

    // check file is valid
    if (!this.validateFile(target.files[0].name, 'pdf')) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertOnlyPDFfilesAreAccepted), 'danger', 'pdf');
      return;
    }

    // check size of file
    if (target.files[0].size > this.maxSizeNotificationFile) {
      this.addAlert(`<strong>¡Error!</strong> ${this.strings.GetText(res.AlertFileSizeExceedsAllowedWeight)} (${Math.round(this.maxSizeNotificationFile / 1049000)} mb)`, 'danger', 'pdf');
      return;
    }

    const file = target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (e: any) => {
      this.fileToUpload = reader.result;

      this.dateFileToUpload = file;
    };

    this.Checklist.newNotificationDoc = true;
    this.addAlert('<strong>' + this.strings.GetText(res.File) + ' ' + file.name + ' ' + this.strings.GetText(res.UploadedCorrectly) + '</strong>', 'success', 'pdf');
  }

  uploadExcel(event: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertSelectOnlyOneFile), 'danger', 'excel');
      return;
    }

    // check file is valid
    if (!this.validateFile(target.files[0].name, 'xlsx')) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted), 'danger', 'excel');
      return;
    }

    this.fileNameUpload = event.target.files[0].name;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));

      this.lsInstruction = [];
      let continueReading = true;
      let orderDisplayInstruction = 1;
      this.excelData.forEach((element, index ) => {
        if (continueReading) {
          if (index != 0) {
            const layoutInstruction = {
              availableComment: false,
              availableOtherOption: false,
              catDetTypeAnswerId: 2602,
              checkInstId: 0,
              checkInstImportReferenceId: 0,
              checkSectId: 0,
              description: '',
              orderDisplay: orderDisplayInstruction,
              qtPhotosMaxRequired: 0,
              qtPhotosMinRequired: 0,
              title: '',
              answers: [],
              checklistSections: []
            };

            const section = {
              checklistId: 0,
              checkSectId: 0,
              checkSectParentId: 0,
              description: '',
              displayTitle: true,
              instructions: [],
              lastDateUpdate: '0001-01-01T00:00:00',
              orderDisplay: 0,
              sectionWeight: 0.0,
              title: ''
            };

            section.title = element[0];
            if (element[0] == '' || element[0] == null) {
              this.addAlert(`<strong>${this.strings.GetText(res.Row)} ${index + 1}, ${this.strings.GetText(res.EnterLevelName)}</strong>`, 'danger', 'excel');
              continueReading = false;
            }

            layoutInstruction.checklistSections.push(section);
            layoutInstruction.title = element[1];
            layoutInstruction.description = element[2];
            layoutInstruction.qtPhotosMinRequired = element[3];
            layoutInstruction.qtPhotosMaxRequired = element[4];

            if (layoutInstruction.qtPhotosMinRequired > layoutInstruction.qtPhotosMaxRequired) {
              this.addAlert(`<strong>${this.strings.GetText(res.Row)} ${index + 1}, ${this.strings.GetText(res.MinimumNumberPhotosMaximumNumberPhotos)}</strong>`, 'danger', 'excel');
              continueReading = false;
            }

            if (layoutInstruction.qtPhotosMinRequired < 0) {
              this.addAlert(`<strong>${this.strings.GetText(res.Row)} ${index + 1}, ${this.strings.GetText(res.MinimumNumberPhotosCannotBeLesThan0)}</strong>`, 'danger', 'excel');
              continueReading = false;
            }

            if (element[5].toLowerCase() == 'si' || element[5].toLowerCase() == 'yes') {
              layoutInstruction.availableComment = true;
            } else {
              layoutInstruction.availableComment = false;
            }
            orderDisplayInstruction++;

            let orderDisplayAnswer = 1;
            for (let i = 6; i <= element.length; i++) {
              const answer = {
                activStoreInstId: 0,
                answerText: '',
                answerValue: 0,
                checkAnswId: 0,
                checkInstId: 0,
                lastDateUpdate: '0001-01-01T00:00:00',
                orderDisplay: 0
              };

              if (element[i] === undefined) {
                break;
              } else {
                // 116 -> Checklist Inventarios
                if (this.cmb_functionality == 116 && i == 6) {
                  if (element[i].toUpperCase() == 'CAPTURA' || element[i].toUpperCase() == 'CAPTURE') {
                    layoutInstruction.catDetTypeAnswerId = 2601;
                    break;
                  }
                }
                answer.answerText = element[i];
                i++;
                answer.answerValue = element[i];
                answer.orderDisplay = orderDisplayAnswer;
                layoutInstruction.answers.push(answer);
                orderDisplayAnswer++;
              }
            }
            this.lsInstruction.push(layoutInstruction);
          }
        } else {
          this.lsInstruction = [];
        }
      });
    };

    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label.textContent = this.fileNameUpload;

    this.isNewChecklist = true;
    this.addAlert(`<strong>${this.strings.GetText(res.File)} ${target.files[0].name} ${this.strings.GetText(res.UploadedCorrectly)}</strong>`, 'success', 'excel');
  }

  validateFile(name: String, extension: String ) {
    let ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext == 'xls') {
      ext = 'xlsx';
    }
    if (ext.toLowerCase() == extension) {
        return true;
    } else {
        return false;
    }
  }

  downloadLayout() {
    const link = document.createElement('a');
    // 116 -> Checklist Inventarios
    if (this.cmb_functionality == 116) {
      link.download = 'layout_checklist_inventarios';
      link.href = 'assets/layout/Layout_checklist_Inventarios.xlsx';
    } else {
      link.download = 'layout_checklist';
      link.href = 'assets/layout/Layout_checklist.xlsx';
    }
    link.click();
  }

  // añadir alert
  addAlert(message: String, type: String, alertType: String): void {
    if (alertType == 'pdf') {
      this.alertsFilePdf = [];
      this.alertsFilePdf.push({
        type: type,
        msg: message
      });
    } else if (alertType == 'excel') {
      this.alertsFileExcel = [];
      this.alertsFileExcel.push({
        type: type,
        msg: message      });
    } else if (alertType == 'addCampaign') {
      this.alertsAddCampaign = [];
      this.alertsAddCampaign.push({
        type: type,
        msg: message      });
    } else if (alertType == 'editCampaign') {
      this.alertsEditCampaign = [];
      this.alertsEditCampaign.push({
        type: type,
        msg: message      });
    } else {
      this.generalAlerts = [];
      this.generalAlerts.push({
        type: type,
        msg: message
      });
    }

  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent, type: String): void {
    if (type == 'pdf') {
      this.alertsFilePdf = this.alertsFilePdf.filter(alert => alert !== dismissedAlert);
    } else if (type == 'excel') {
      this.alertsFileExcel = this.alertsFileExcel.filter(alert => alert !== dismissedAlert);
    } else if (type == 'addCampaign') {
      this.alertsAddCampaign = this.alertsAddCampaign.filter(alert => alert !== dismissedAlert);
    } else if (type == 'editCampaign') {
      this.alertsEditCampaign = this.alertsEditCampaign.filter(alert => alert !== dismissedAlert);
    }
  }

  // Guardar Checklist
  saveChecklist() {
    if (this.cmb_functionality == -1) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectChecklistFunctionality) + '</strong>', 'danger', 'general');
      return;
    }

    if (this.txt_title.trim() == '') {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertEnterTheTitleOfTheChecklist) + '</strong>', 'danger', 'general');
      return;
    }

    // 102 -> Cambio de Nivel
    if (this.cmb_functionality == 102) {
      if (this.cmb_campaign == -1) {
        this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectCampaignFromChecklist) + '</strong>', 'danger', 'general');
        return;
      }
    } else {
      if (this.cmb_periodicity == -1 && this.cmb_functionality != 116) {
        this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectPeriodicityOfTheChecklist) + '</strong>', 'danger', 'general');
        return;
      }
    }

    if (this.Checklist.stores == null) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectOneStoreForTheChecklist) + '</strong>', 'danger', 'general');
      return;
    }

    if (this.cmb_notification == -1) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectIfYouRequireNotice) + '</strong>', 'danger', 'general');
      return;
    }

    if (this.cmb_notification == 1) {
      if (this.cmb_notification_date == -1) {
        this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectNoticeDate) + '</strong>', 'danger', 'general');
        return;
      }

      if (this.dateFileToUpload == null) {
        if (this.Checklist.newNotificationDoc) {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectNoticeDocument) + '</strong>', 'danger', 'general');
          return;
        }
        if (this._action == this.add) {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectNoticeDocument) + '</strong>', 'danger', 'general');
          return;
        }
      }
    }

    if (this.lsInstruction.length == 0) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertUploadFileWithNecessaryInstructions) + '</strong>', 'danger', 'general');
      return;
    }

    const checklist : Checklist = {
      catDetChecklistStatusId: 44,
      catDetTaskTypeId: this.cmb_functionality,
      checklistId: 0,
      lastUserNameUpdate: 'System',
      instructions: this.lsInstruction,
      organizationId: this.cmb_organization,
      sections: [],
      storeId: 0
    };

    if (this._action == this.edit) {
      checklist.checklistId = this._checklistId;
    }

    this.Checklist.checklist = checklist;
    this.Checklist.newChecklist = this.isNewChecklist;

    let notificationDocument = {
      blobMobSyncAuxId: '00000000-0000-0000-0000-000000000000',
      blobName: '',
      blobStorId: 0,
      catDetBlobStorageSrcId: 75,
      catDetReferenceTableId: 0,
      contentType: '',
      fileData: null,
      fileBase64 : null,
      lastDateUpdate: '0001-01-01T00:00:00',
      syncAction: 0,
      takenDate: '0001-01-01T00:00:00',
      thumbnail: '',
    };
    if (this.cmb_notification == 1 && this._action == this.add) {
      notificationDocument.blobName = this.dateFileToUpload.name;
      notificationDocument.contentType = this.dateFileToUpload.type;
      notificationDocument.fileBase64 = this.fileToUpload;
    } else if (this.cmb_notification == 1 && this._action == this.edit) {
      if (this.Checklist.newNotificationDoc) {
        if (this.Checklist.notificationDocument != null) {
          notificationDocument.blobStorId = this.Checklist.notificationDocument.blobStorId;
        }
        notificationDocument.blobName = this.dateFileToUpload.name;
        notificationDocument.contentType = this.dateFileToUpload.type;
        notificationDocument.fileBase64 = this.fileToUpload;
      } else {
        notificationDocument = this.Checklist.notificationDocument;
      }
    } else if (this.cmb_notification == 0 && this._action == this.edit) {
      if (this.Checklist.notificationDocument != null) {
        notificationDocument.blobStorId = this.Checklist.notificationDocument.blobStorId;
      }
    }
    this.Checklist.notificationDocument = notificationDocument;
    this.dateFileToUpload == null;

    const task = {
      campaignCalendarId: this.cmb_campaign,
      catDetNotificationDateId: this.cmb_notification_date,
      catDetTaskRequestTypeId: 46,
      catDetTaskStatusId: this.cmb_status,
      catDetTaskTypeId: this.cmb_functionality,
      checklistId: 0,
      description: '',
      isMaximumTimeRequired: this.check_isMaximumTimeRequired,
      lastDateUpdate: '0001-01-01T00:00:00',
      lastUserNameUpdate: 'System',
      lockedBeforeReadNotif:  this.check_readNotif,
      maximumDateRequired: null,
      maximumTimeRequired: null,
      notificationMessage: this.txta_notification,
      sendNotification: false,
      taskId: 0,
      title: this.txt_title
    };

    if (this.check_isMaximumTimeRequired) {
      task.maximumTimeRequired = `${this.maximumTimeRequired.hour}:${this.maximumTimeRequired.minute}:${this.maximumTimeRequired.second}`;
    }

    if (this._action == this.edit) {
      task.taskId = this._taskId;
      task.checklistId = this._checklistId;
    }

    if (this.cmb_notification == 1) {
      task.sendNotification = true;
    } else {
      task.sendNotification = false;
      task.catDetNotificationDateId = 0;
    }
    this.Checklist.task = task;

    const taskSchedule = {
      catDetTaskSchedTypeId: this.cmb_periodicity,
      detail: [],
      endDate: new Date(),
      startDate: new Date(),
      taskId: 0,
      taskSchedId: 0
    };

    if (this._action == this.edit) {
      taskSchedule.taskId = this._taskId;
      taskSchedule.taskSchedId = this.Checklist.taskSchedule.taskSchedId;
    }

    // 102 -> Cambio de Nivel
    if (this.cmb_functionality == 102) {
      const campaignAux = this.lsCampaignCalendar.find( x => x.campaignCalendarId == Number(this.cmb_campaign));

      // 151 -> Unica Ocasión
      taskSchedule.catDetTaskSchedTypeId = 151;
      taskSchedule.endDate = campaignAux.startDate;
      taskSchedule.startDate = campaignAux.startDate;
    } else {
      taskSchedule.endDate = this.txt_end_date;
      taskSchedule.startDate = this.txt_start_date;

      if (this.cmb_periodicity == this._periodicityWeekenly) {
        for (let i = 1; i <= 7; i++) {
          const detail = {
            active: true,
            lastDateUpdate: '0001-01-01T00:00:00',
            numberDay: i,
            taskSchedDetId: 0,
            taskSchedId: 0
          };

          switch (i) {
            case 1: {
              if (this.check_day1) {
                taskSchedule.detail.push(detail);
              }
              break;
            }
            case 2: {
              if (this.check_day2) {
                taskSchedule.detail.push(detail);
              }
              break;
            }
            case 3: {
              if (this.check_day3) {
                taskSchedule.detail.push(detail);
              }
              break;
            }
            case 4: {
              if (this.check_day4) {
                taskSchedule.detail.push(detail);
              }
              break;
            }
            case 5: {
              if (this.check_day5) {
                taskSchedule.detail.push(detail);
              }
              break;
            }
            case 6: {
              if (this.check_day6) {
                taskSchedule.detail.push(detail);
              }
              break;
            }
            case 7: {
              if (this.check_day7) {
                taskSchedule.detail.push(detail);
              }
              break;
            }
          }
        }
      }

      // 116 -> Checklist Inventario
      if (this.cmb_functionality == 116) {
        task.maximumDateRequired = this.txt_end_date;
        taskSchedule.catDetTaskSchedTypeId = 151; // 151 -> Unica Ocasión
        taskSchedule.endDate = this.txt_start_date;
      }

      this.Checklist.task.campaignCalendarId = -1;
    }

    this.Checklist.taskSchedule = taskSchedule;

    this.loading = true;
    if (this._action == this.add) {
      this._facadeChecklist.SaveChecklist(this.Checklist).subscribe(result => {
          if (result.completed) {
            this.addAlert('<strong>' + result.message + '</strong>', 'success', 'general');
            this.readonly = true;
          } else {
            this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotSaveChecklist) + ', ' + result.message + '</strong>', 'danger', 'general');
          }
          this.loading = false;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
        return;
      });
    } else if (this._action == this.edit) {
      this._facadeChecklist.EditChecklist(this.Checklist).subscribe(result => {
          if (result.completed) {
            this.addAlert('<strong>' + result.message + '</strong>', 'success', 'general');
            if (result.data == null) {
              this.readonly = true;
            } else {
              this.Checklist = result.data;
              this.Checklist.newNotificationDoc = false;
              this.dateFileToUpload = null;
            }
          } else {
            this.addAlert('<strong>' + this.strings.GetText(res.AlertCouldNotEditChecklist) + ', ' + result.message + '</strong>', 'danger', 'general');
          }
          this.loading = false;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
        return;
      });
    }
  }

  saveCampaign() {
    if (this.txt_campaignAdd == '') {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertEnterCampaignName) + '</strong>', 'danger', 'addCampaign');
      return;
    }

    if (this.txt_start_date_campaign == null || this.txt_end_date_campaign == null) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectStartDateDeadline) + '</strong>', 'danger', 'addCampaign');
      return;
    }

    if (this.cmb_organization_campaignAdd.toString().trim().length == 0 || this.cmb_organization_campaignAdd.toString() == '-1') {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectOrganization) + '</strong>', 'danger', 'addCampaign');
      return;
    }

    const campaignAux = this.lsCampaign.find( x => x.name == this.txt_campaignAdd.trim());

    const campaignCalendar = {
      campaignCalendarId: 0,
      catDetCampaignId: campaignAux == null ? 0 : campaignAux.catDetId,
      startDate: this.txt_start_date_campaign,
      endDate: this.txt_end_date_campaign,
      lastUserNameUpdate: '',
      campaignName: campaignAux == null ? this.txt_campaignAdd : campaignAux.name,
      catDetTaskTypeId: Number(this.cmb_functionality),
      organizationId: this.cmb_organization_campaignAdd
    };

    this.loading = true;
    this._facadeCampaignCalendar.saveCampaign(campaignCalendar).subscribe(result => {
        if (result.completed) {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertCampaignCreatedSuccessfully) + '</strong>', 'success', 'addCampaign');
          this.loading = false;
          this.loadCampaigns();
        } else {
          this.loading = false;
          this.addAlert('<strong>' + result.message + '</strong>', 'danger', 'addCampaign');
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger', 'addCampaign');
        return;
      }
    );
  }

  editCampaignMet() {
    if (this.cmb_campaignEdit == -1) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectCampaignToEdit) + '</strong>', 'danger', 'editCampaign');
      return;
    }

    if (this.txt_start_date_campaignEdit == null || this.txt_end_date_campaignEdit == null) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectStartDateDeadline) + '</strong>', 'danger', 'editCampaign');
      return;
    }

    if (this.cmb_organization_campaignEdit == -1) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertSelectOrganization) + '</strong>', 'danger', 'editCampaign');
      return;
    }

    const campaignCalendar = {
      campaignCalendarId: this.cmb_campaignEdit,
      catDetCampaignId: 0,
      startDate: this.txt_start_date_campaignEdit,
      endDate: this.txt_end_date_campaignEdit,
      lastUserNameUpdate: '',
      campaignName: ''
    };

    this.loading = true;
    this._facadeCampaignCalendar.editCampaign(campaignCalendar).subscribe(result => {
        if (result.completed) {
          this.addAlert('<strong>' + this.strings.GetText(res.AlertCampaignSuccessfullyEdited) + '</strong>', 'success', 'editCampaign');
          this._facadeCampaignCalendar.Get(Number(this.cmb_functionality)).subscribe(result => {
            if (result.completed) {
                this.lsCampaignCalendar = result.data;
            }
            this.loading = false;
          }, error => {
            this.loading = false;
            this.addAlert('<strong>' + error + '</strong>', 'danger', 'editCampaign');
            return;
          });
        } else {
          this.loading = false;
          this.addAlert('<strong>' + result.message + '</strong>', 'danger', 'editCampaign');
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger', 'editCampaign');
        return;
      }
    );
  }

  selectEvent(item) {
    this.campaign = item.name;
    this.txt_campaignAdd = this.campaign;
  }

  onChangeSearch(val: string) {
    this.campaign = val.toUpperCase();
    this.txt_campaignAdd = this.campaign;
  }

  loadCampaigns(selectedCampaign = -1) {
    this.language = 0;
    if (!this.isSpanish) {
        this.language = 1;
    }
    this.lsStores = [];

    this._facadeCatDet.Get(42, this.language, this.cmb_organization).subscribe(result => {
      if (result.completed) {
        this.lsCampaign = result.data;

        this._facadeCampaignCalendar.Get(Number(this.cmb_functionality)).subscribe(result => {
          if (result.completed) {
              this.lsCampaignCalendar = result.data.find( x => x.catDetTaskTypeId == this.cmb_functionality);
              this.cmb_campaign = selectedCampaign;
          }
          if (this.cmb_campaign > 0) {
            this.loadStoreToCampaing();
          }
          this.loading = false;
          this.getCampaignByFunctionality();
        }, error => {
          this.loading = false;
          this.addAlert('<strong>' + error + '</strong>', 'danger', 'addCampaign');
          return;
        });

      }
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger', 'addCampaign');
      return;
    });
  }

  loadStoreToCampaing() {
    if (this.cmb_campaign > 0 ) {
      const campaign =  this.lsCampaignCalendar.find( x => x.catDetId == this.cmb_campaign );
      if  (campaign != null && campaign != undefined) {
          this._facadeStore.GetByOrganizationId(campaign.organizationId).subscribe( response => {
            if (response != null ) {
              if (response.completed && response.data != null) {
                this.lsStores = response.data;
              } else {
                this.addAlert('<strong>' + this.strings.GetText(res.AlertStoresCouldNotBeObtained) + ', ' + response.message + '</strong>', 'danger', 'general');
              }
          }
          this.loading = false;
        }
          , error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger', 'general');
            return;
          });
      }
    }
    this.loading = false;
  }  

}

